export default "__VITE_ASSET__Dtc82QI___"